<div class="notifications-container">
  @for (notif of notifications; track notif.id) {
    <div class="custom-notification-wrapper">
      <div
        class="custom-notification po-shadow"
        [ngClass]="notif.config.colorClass"
      >
        <div class="notification-content">
          <span
            class="po-icon notification-icon"
            [ngClass]="notif.config.icon"
          ></span>
          <span class="notification-message">{{ notif.message }}</span>
        </div>

        <span
          class="an an-x close-icon-btn"
          (click)="close(notif.id)"
          title="Fechar notificação"
        ></span>
      </div>
    </div>
  }
</div>
